
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitoashtavinayakdarshancabs() {



    const cardData =
    {
        keyword: 'Mumbai to Ashtavinayak Darshan Cabs ',
        heading: 'Skyline Cabs: Mumbai to Ashtavinayak Darshan Cabs ',
        headingDescription: 'Skyline Cabs offers a divine and comfortable Mumbai to Ashtavinayak Darshan Cabs service for devotees embarking on the sacred pilgrimage to the eight revered Ganesh temples in Maharashtra. Our well-maintained fleet and experienced drivers ensure a smooth and spiritually fulfilling journey across the Ashtavinayak circuit, including Mayureshwar, Siddhatek, Ballaleshwar, Varadvinayak, Chintamani, Girijatmaj, Vighneshwar, and Mahaganapati. With flexible travel plans, transparent pricing, and 24/7 customer support, Skyline Cabs makes your pilgrimage peaceful and hassle-free. Book your Ashtavinayak Darshan cab from Mumbai today and experience a journey of faith and comfort.',

        top: 'Top Places to Visit in Ashtavinayak with Skyline Cabs',

"topPlaces": [
    {
        "title": "Mayureshwar Temple, Morgaon",
        "description": "Located in Morgaon, this temple is considered the starting and ending point of the Ashtavinayak Yatra. It features a beautiful idol of Lord Ganesha riding a peacock and is surrounded by a picturesque village setting."
    },
    {
        "title": "Siddhivinayak Temple, Siddhatek",
        "description": "Situated on the banks of the Bhima River, Siddhatek is home to a powerful swayambhu (self-manifested) idol of Ganesha. It’s believed that Lord Vishnu himself worshipped Ganesha here before slaying demons."
    },
    {
        "title": "Ballaleshwar Temple, Pali",
        "description": "This is the only temple named after a devotee of Lord Ganesha—Ballal. Located in Pali, the temple is known for its unique architecture and deep-rooted spiritual ambiance."
    },
    {
        "title": "Varadvinayak Temple, Mahad",
        "description": "Located in Mahad near Khopoli, this temple is famous for its open sanctum and lamp that has been continuously burning since 1892. Devotees can directly enter the sanctum and offer prayers."
    },
    {
        "title": "Chintamani Temple, Theur",
        "description": "Situated near Pune, Theur’s Chintamani Temple is associated with Ganesha removing the worries (chinta) of devotees. It is one of the most visited and revered among the eight temples."
    },
    {
        "title": "Girijatmaj Temple, Lenyadri",
        "description": "Located inside a Buddhist cave complex, Girijatmaj is the only Ashtavinayak temple in a cave. It is believed that Goddess Parvati performed penance here to beget Ganesha as her son."
    },
    {
        "title": "Vighnahar Temple, Ozar",
        "description": "Famous for its grand architecture and scenic surroundings, the Ozar temple is dedicated to the remover of obstacles, Vighnahar. The temple features a golden dome and a spacious courtyard."
    },
    {
        "title": "Mahaganapati Temple, Ranjangaon",
        "description": "Located on the Pune–Ahmednagar highway, this temple houses a majestic idol of Mahaganapati with ten trunks and twenty arms, believed to be worshipped by Lord Shiva himself before his battle with Tripurasura."
    }
],

"services": [
    {
      "name": "Mumbai to Ashtavinayak Cab",
      "description": "Skyline Cabs provides a reliable and comfortable taxi service from Mumbai to Ashtavinayak temples. Visit all eight sacred Ashtavinayak temples with our professional drivers, ensuring a smooth and peaceful pilgrimage."
    },
    {
      "name": "Ashtavinayak Darshan Taxi Service",
      "description": "Book a dedicated taxi for your Ashtavinayak Darshan with Skyline Cabs. Our cabs are well-maintained and perfect for a day-long pilgrimage tour to the Ashtavinayak temples."
    },
    {
      "name": "Ashtavinayak Tour from Mumbai",
      "description": "Take a guided Ashtavinayak temple tour from Mumbai with Skyline Cabs. Experience the comfort and luxury of our cabs as you visit the eight important Ganesh temples located around Pune."
    },
    {
      "name": "Mumbai to Ashtavinayak One Day Cab",
      "description": "Plan a one-day trip to the Ashtavinayak temples from Mumbai with Skyline Cabs. We offer a convenient and time-efficient service to complete the darshan in a single day, with flexible pickup and drop-off times."
    },
    {
      "name": "Ashtavinayak Darshan Cab Booking",
      "description": "Easily book your Ashtavinayak Darshan taxi with Skyline Cabs. We offer various options like sedans, SUVs, and minivans for a comfortable and divine experience."
    },
    {
      "name": "Taxi Service for Ashtavinayak Tour",
      "description": "Skyline Cabs offers a reliable taxi service for the Ashtavinayak Darshan tour. Our drivers are well-versed with the route and can ensure timely visits to all eight temples, making your trip hassle-free."
    },
    {
      "name": "Mumbai to Ashtavinayak Package",
      "description": "Skyline Cabs provides an all-inclusive Ashtavinayak package from Mumbai. The package covers transportation, sightseeing, temple visits, and all essential services for a smooth pilgrimage journey."
    }
  ],
  "tableData": [
    ["Mumbai to Ashtavinayak Cab", "Ashtavinayak Darshan Taxi Service"],
    ["Ashtavinayak Tour from Mumbai", "Mumbai to Ashtavinayak One Day Cab"],
    ["Ashtavinayak Darshan Cab Booking", "Taxi Service for Ashtavinayak Tour"],
    ["Mumbai to Ashtavinayak Package", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Ashtavinayak Darshan Cab Service",
        "WhyChoosedescription": "Our Mumbai to Ashtavinayak Darshan cab service offers a reliable and comfortable ride, ensuring you experience the spiritual journey to the eight sacred Ganesh temples with ease."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Cabs",
        "WhyChoosedescription": "Our cabs are spacious and comfortable, offering a smooth ride as you visit the Ashtavinayak temples. Enjoy ample legroom and a relaxed journey for a truly peaceful pilgrimage."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We provide affordable pricing for the Mumbai to Ashtavinayak Darshan trip, with transparent pricing and no hidden charges. Get a hassle-free experience at a great value."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our professional drivers are knowledgeable about the routes and temples of the Ashtavinayak pilgrimage. They ensure a safe and smooth journey while making your trip stress-free."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "All our vehicles are regularly maintained, sanitized, and thoroughly cleaned to ensure a safe, hygienic, and comfortable travel experience on your Ashtavinayak Darshan journey."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Choose from flexible packages for your Mumbai to Ashtavinayak Darshan trip. Whether you want a one-day trip or a more extended journey, we provide options that suit your schedule."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Booking your Mumbai to Ashtavinayak Darshan cab is easy with our 24/7 customer support available online or via phone. Enjoy instant booking confirmation and a seamless experience."
    },
    {
        "WhyChooseheading": "Ideal for Spiritual and Group Travel",
        "WhyChoosedescription": "Our cabs are perfect for solo pilgrims, family groups, or friends traveling together for the Ashtavinayak Darshan. We ensure that your journey is both comfortable and spiritually fulfilling."
    }
]






    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Ashtavinayak Darshan with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Ashtavinayak Darshan is easy. Simply visit our website, use our mobile app, or call customer support. Enter your pickup location, travel date, and select the “Ashtavinayak Darshan” package for your journey.',
        },
        {
            id: 2,
            question: 'What are the 8 temples covered in the Ashtavinayak Darshan tour?',
            answer:
                'The Ashtavinayak Darshan tour includes visits to the following eight Ganesh temples: Moreshwar (Morgaon), Siddhivinayak (Siddhatek), Ballaleshwar (Pali), Chintamani (Theur), Varadvinayak (Mahad), Shree Vighneshwar (Ozar), Girijatmaj (Lenyadri), and Mahaganapati (Ranjangaon).',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Ashtavinayak Darshan trip?',
            answer:
                'We offer a range of vehicles for the Ashtavinayak Darshan trip, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and Tempo Travellers. Choose a vehicle based on your group size and comfort requirements.',
        },
        {
            id: 4,
            question: 'Is the pricing for the Mumbai to Ashtavinayak Darshan cab fixed?',
            answer:
                'Yes, we offer fixed pricing for the Ashtavinayak Darshan tour. The fare includes vehicle rental, driver charges, fuel, tolls, and taxes. There are no hidden charges, and you will know the total fare before confirming the booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-day or two-day Ashtavinayak Darshan trip from Mumbai?',
            answer:
                'Yes, you can choose between a one-day or two-day Ashtavinayak Darshan trip. For the two-day trip, we can arrange overnight stays and breaks at various locations.',
        },
        {
            id: 6,
            question: 'Are stopovers allowed during the Ashtavinayak Darshan tour?',
            answer:
                'Yes, we allow stops for refreshments, meals, and rest breaks. If you wish to explore other nearby places, just let the driver know, and we will make the necessary arrangements.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Ashtavinayak Darshan comfortable and well-maintained?',
            answer:
                'Absolutely. All our vehicles are regularly maintained, sanitized, and thoroughly checked for safety. We prioritize comfort, ensuring a smooth ride during your Ashtavinayak Darshan tour.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Ashtavinayak Darshan tour?',
            answer:
                'We accept various payment options, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online transactions are secure and hassle-free.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Ashtavinayak Darshan booking?',
            answer:
                'Yes, you can modify or cancel your booking through our website, mobile app, or by contacting our customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Ashtavinayak Darshan tour?',
            answer:
                'Skyline Cabs offers reliable service, experienced drivers, comfortable vehicles, and transparent pricing for your Ashtavinayak Darshan trip. We ensure a smooth, safe, and spiritual journey with impeccable customer service.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "We had an amazing Ashtavinayak Darshan trip with Skyline Cabs. The driver was knowledgeable about the routes, and the car was comfortable for the long journey. A truly blessed experience!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Booked the Ashtavinayak Darshan tour from Mumbai with Skyline Cabs. It was well-organized, and the driver made sure we were comfortable throughout the journey. Highly recommend for spiritual trips!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Darshan Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-ashtavinayak-cab.jpg",
  "description": "Book Mumbai to Ashtavinayak Darshan Cab with Skyline Cabs for a sacred pilgrimage covering all 8 Ganpati temples. Choose from AC sedans, SUVs, or tempo travellers for a comfortable spiritual journey with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8617"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-ashtavinayak-darshan-cab"
  }
};



      
   
      


    return (
        <div>
<Helmet>
  <title>Mumbai to Ashtavinayak Darshan Cab | 8 Ganpati Tour | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ashtavinayak Darshan Cab with Skyline Cabs for a sacred pilgrimage covering all 8 Ganpati temples. Choose from AC sedans, SUVs, or tempo travellers for a comfortable spiritual journey with experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Ashtavinayak Darshan Cab, Ashtavinayak Yatra from Mumbai, 8 Ganpati Tour Mumbai, Ashtavinayak Cab Booking, Mumbai to Ganpati Temples Cab, AC Cab for Ashtavinayak, SUV Tempo Traveller for Ashtavinayak, Skyline Cabs Ashtavinayak Darshan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/82.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoashtavinayakdarshancabs;